import styled from 'styled-components'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex).attrs({
  py: [6, 6, 0],
})`
  align-items: center;
  height: 100%;
  box-sizing: border-box;
`

export const ImageHolder = styled(Flex)
  .attrs({
    width: [320, 320, 320, 320, 440, 540],
    height: [175, 175, 175, 175, 240, 300],
    maxWidth: ['100%', '100%', '90%'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  border-radius: 10px;
  position: relative;
`
